"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
class Socket {
    constructor() {
        this.url = window.AppearMe.appConfigs.url.replace('/api', '');
        this.subscribers = [];
        this.unsubscribers = [];
    }
    connect() {
        const options = {
            query: {}
        };
        options.query['appearme-token'] = localStorage.getItem('token');
        options.query['user-agent'] = window.navigator.userAgent;
        this.socket = socket_io_client_1.default(`${this.url}`, Object.assign(Object.assign({}, options), { transports: ['websocket'] }));
        this.socket.on('connect', () => {
            for (const s of this.subscribers) {
                this.subscribe(s.eventName, s.cb);
            }
            for (const s of this.unsubscribers) {
                this.unsubscribe(s.eventName, s.cb);
            }
        });
    }
    subscribe(eventName, cb) {
        if (!this.socket) {
            return this.subscribers.push({ eventName, cb });
        }
        return this.socket.on(eventName, cb);
    }
    unsubscribe(eventName, cb) {
        if (!this.unsubscribers) {
            return this.unsubscribers.push({ eventName, cb });
        }
        return this.socket.removeListener(eventName, cb || void (1));
    }
    emit(eventName, data) {
        return this.socket.emit(eventName, data);
    }
}
exports.default = Socket;
